<div class="battery-range-section"
  [class.battery-range-section__is-tooltip]="isTooltip">
  <mat-icon class="battery-range-section__side-icon"
    *ngIf="!isTooltip"
    svgIcon="ic-replay-balloon-battery-range"></mat-icon>
  <mat-icon class="battery-range-section__side-icon"
    *ngIf="isTooltip"
    svgIcon="ic-replay-segment-battery-range"></mat-icon>
  <div class="battery-range-section__details">
    <div class="battery-range-section__details__row"
      [class.battery-range-section__details__row--gap]="isTooltip">
      <span class="battery-range-section__details__row__date">{{ startTime }}</span>
      <fm-ev-battery-section [isTooltip]="isTooltip"
        [isCharging]="isChargingStart"
        [percentage]="startPercentage"
        [userSettings]="userSettings">
      </fm-ev-battery-section>
    </div>
    <div class="battery-range-section__details__row"
      [class.battery-range-section__details__row--gap]="isTooltip">
      <span class="battery-range-section__details__row__date">{{ endTime }}</span>
      <fm-ev-battery-section [isTooltip]="isTooltip"
        [isCharging]="isChargingEnd"
        [percentage]="endPercentage"
        [userSettings]="userSettings">
      </fm-ev-battery-section>
    </div>
  </div>
</div>
